import React, { Component } from "react";
import Table from "react-bootstrap/Table";
import LeftSideNavigation from "../../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
// import { SuperAdminTopTextSearchIcon } from "../../superAdminReusable/reusableTable/SuperAdminTopTextSearchIcon";
// import Filter from "../../../reusableComponents/allPopupReusable/tableNumberPopup/Filter";
import { AllVendorTableHead } from "./firstPageTable/AllVendorTableHead";
import { AllVendorTableBody } from "./firstPageTable/AllVendorTableBody";
import Alert from "react-s-alert";
import CSVDownloader from "../../../../reusableComponents/csvDownload/csvDownload";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../../../store/actions/errorActions";
import {
  get_all_admin_active_vendors,
  get_vendor_single_rating_review,
  superadmin_approved_notapproved,
} from "../../../../../store/actions/SuperAdminActions/adminPendingActiveDinersAction";
import { getSubCateogryWithCategoryId } from "../../../../../store/actions/SuperAdminActions/adminCategoryAndIconsAction";
import {
  get_all_vendor_seating_information,
  get_single_vendor_restaurant_information,
} from "../../../../../store/actions/SuperAdminActions/adminSeatingDashboardAllAction";
import isEmpty from "../../../../../store/validation/is-Empty";
import store from "../../../../../store/store";
import {
  SET_VENDOR_INFORMATION,
  SET_MERCHANT_EDIT_ACTION_TYPE,
} from "../../../../../store/types";
import { FilterAllVendorsActive } from "./FilterAllVendorsActive";

import moment from "moment";
import { AmealioLoader } from "../../../../Loader/AmealioLoader";
import { RightSideCountTop } from "../../superAdminReports/orderingReports/SuperAdminPendingOrderActivityReports";
import { SortComponent } from "../../../../reusableComponents/SortAndFilterComponent/SortComponent";
import { SmallLoader } from "../../../../Loader/SmallLoader";
import BasicPagination from "../../../../Pagination/Pagination";
import {
  getBusinessTimingsStatus,
  statuses,
} from "../../../../reusableComponents/BusinessTimingsStatus";
import NoContent from "../../../../reusableComponents/NoContentComponent";

export class SuperAdminMainVendorComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentState: true,
      displayFilter: false,
      adminAllActiveDiners: [],
      activeCount: 0,
      totalCount: 0,
      search: "",
      locationSearch: "",
      startDate: "",
      endDate: "",
      startDateSearch: "",
      endDateSearch: "",
      sortBy: "name",
      location: "",
      rating: "",
      startRatingSearch: "",
      endRatingSearch: "",
      categoryList: [],
      downloadData: [],
      loading: false,
      resType: "",
      resTypeSearch: "",
      anchorEl: null,
      restaurantReverse: "",
      page: 1,
      start: 0,
      end: 10,
      filteredData: [],
      statusFilter: "",
      sortByStatus: "",
      softOnboardedSearch: false,
      softOnboarded: false,
    };
  }

  componentDidMount() {
    if (this.props.get_all_admin_active_vendors) {
      this.props.get_all_admin_active_vendors(
        this.props.auth.user.accessToken,
        true,
        moment().subtract(30, "days").format("YYYY-MM-DD"),
        moment().format("YYYY-MM-DD")
      );
    }
    this.props.getSubCateogryWithCategoryId(
      this.onSuccessGetSubCategory,
      "5f562c9094ac7fdf47ea1d0a"
    );
  }

  onSuccessGetSubCategory = (data) => {
    var subC = [];

    for (var i = 0; i < data.length; i++) {
      if (data[i].status === "APPROVED") subC.push(data[i].title);
    }
    this.setState({ categoryList: subC });
    // setLoading(false);
    return subC;
  };

  static getDerivedStateFromProps(nextProps, nextState) {
    if (
      !isEmpty(nextProps.admin_active_vendors.data !== nextState.hasSetActive)
    ) {
      return {
        adminAllActiveDiners: nextProps.admin_active_vendors.data,
        activeCount: nextProps?.admin_active_vendors?.stats?.activeCount,
        totalCount: nextProps?.admin_active_vendors?.stats?.totalCount,
        hasSetActive: true,
      };
    }
    return null;
  }

  /**************************
   * @DESC - Current and Saving HANDLER
   ***************************/
  toggleFunction = (e) => {
    this.setState({
      [e.target.name]: e.target.checked,
    });
  };

  handleShowFilter = (e) => {
    this.setState({
      displayFilter: !this.state.displayFilter,
      startDate: "",
      endDate: "",
      startDateSearch: "",
      endDateSearch: "",
      locationSearch: "",
      location: "",
      rating: "",
      softOnboardedSearch: false,
      softOnboarded: false,
      startRatingSearch: "",
      endRatingSearch: "",
      resType: "",
      resTypeSearch: "",
    });
  };

  ratingReviewAction = (data) => (e) => {
    this.props.get_vendor_single_rating_review(
      data,
      0,
      this.onReviewSuccess(data)
    );
  };

  onReviewSuccess = (data) => (e) => {
    this.props.history.push({
      pathname: "/superadminvendorsratingview",
      state: { data: data },
    });
  };

  adminSeatingDashboardAction = (data) => (e) => {
    this.props.get_all_vendor_seating_information(
      data,
      this.successCallback(data)
    );
  };

  successCallback = (data) => (e) => {
    store.dispatch({
      type: SET_VENDOR_INFORMATION,
      payload: data,
    });
    this.props.history.push({
      pathname: "/superadminseatingdashboard",
      state: { data: data },
    });
  };

  handleProfileClick = (data) => (e) => {
    this.props.history.push({
      pathname: "/activevendorsprofileview",
      state: { data: data },
    });
  };

  handleEditMerchantData = (data) => (e) => {
    const vendorId = data?.vendor_id;
    const token = this.props?.auth?.user?.accessToken;
    this.props.get_single_vendor_restaurant_information(
      token,
      vendorId,
      this.onSuccess
    );
  };

  onSuccess = (e) => {
    store.dispatch({
      type: SET_MERCHANT_EDIT_ACTION_TYPE,
      payload: true,
    });
    this.props.history.push({
      pathname: "/admin-edit-subscription",
      // pathname: "/admin_edit_mapdetails_location",
    });
  };

  approvedPendingAction = (data) => (e) => {
    const vendorId = data.vendor_id;
    const token = this.props.auth.user.accessToken;
    const formData = {
      approve: false,
    };
    this.props.superadmin_approved_notapproved(
      formData,
      vendorId,
      token,
      this.onApprovedFalseModel
    );
  };

  onApprovedFalseModel = (e) => {
    Alert.success(`<h4>Restaurant Deactivate Successfully</h4>`, {
      position: "top-right",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
    this.props.get_all_admin_active_vendors(
      this.props.auth.user.accessToken,
      true,
      moment().subtract(30, "days").format("YYYY-MM-DD"),
      moment().format("YYYY-MM-DD")
    );
  };

  handleChange = () => {
    this.setState({
      softOnboarded: !this.state.softOnboarded,
    });
  };

  onClickSearchButton = () => {
    const startDate = this.state.startDate;
    const endDate = this.state.endDate;
    const rating = this.state.rating;
    this.setState({
      startDateSearch: startDate,
      endDateSearch: endDate,
      locationSearch: this.state.location,
      resTypeSearch: this.state.resType,
      softOnboardedSearch: this.state.softOnboarded,
      displayFilter: !this.state.displayFilter,
    });
    // if (rating === "0-1") {
    //   this.setState({ startRatingSearch: 0, endRatingSearch: 1 });
    // } else if (rating === "1-2") {
    //   this.setState({ startRatingSearch: 1, endRatingSearch: 2 });
    // } else if (rating === "2-3") {
    //   this.setState({ startRatingSearch: 2, endRatingSearch: 3 });
    // } else if (rating === "3-4") {
    //   this.setState({ startRatingSearch: 3, endRatingSearch: 4 });
    // } else if (rating === "4-5") {
    //   this.setState({ startRatingSearch: 4, endRatingSearch: 5 });
    // }
  };

  sortByChangeCode = (event) => {
    const sortByValue = event.target.value;
    this.setState({ sortBy: sortByValue });
    let startDate = "";
    let endDate = new Date();
    if (sortByValue === "name") {
      this.setState({ startDateSearch: "", endDateSearch: "" });
    } else if (sortByValue === "Today") {
      startDate = new Date();
      this.setState({
        startDateSearch: moment(startDate).format("YYYY-MM-DD"),
        endDateSearch: moment(endDate).format("YYYY-MM-DD"),
      });
    }
  };

  handleClick = (event) => {
    this.setState({
      anchorEl: event.currentTarget,
    });
  };
  handleClose = () => {
    this.setState({
      anchorEl: null,
    });
  };
  handleSelect = (value) => (e) => {
    this.setState({
      restaurantReverse: value,
      restaurant_type: "",
      sortByStatus: "",
    });
    this.handleClose();
  };

  handleBatchChange = (pageNo) => {
    window.scrollTo(0, 0);
    var calcStart = pageNo * 10 - 10;
    this.setState({ start: calcStart, end: pageNo * 10, page: pageNo });
  };

  renderAllVendorsBody = () => {
    const { adminAllActiveDiners, start, end } = this.state;
    let filtereddata = [];
    if (this.state.restaurantReverse === "A-Z") {
      filtereddata = adminAllActiveDiners.sort((a, b) => {
        if (a.restaurant_name < b.restaurant_name) return -1;
        if (a.restaurant_name > b.restaurant_name) return 1;
        return 0;
      });
    } else if (this.state.restaurantReverse === "Z-A") {
      filtereddata = adminAllActiveDiners.sort((a, b) => {
        if (a.restaurant_name < b.restaurant_name) return 1;
        if (a.restaurant_name > b.restaurant_name) return -1;
        return 0;
      });
    }
    // else {
    //   filtereddata =
    //     adminAllActiveDiners &&
    //     adminAllActiveDiners.filter((activeVendor) => activeVendor);
    // }

    filtereddata =
      adminAllActiveDiners &&
      adminAllActiveDiners.filter((item) => {
        return (
          (((item && item._id && item._id.includes(this.state.search)) ||
            (item &&
              item.restaurant_name &&
              item.restaurant_name
                .toLowerCase()
                .includes(this.state.search.toLowerCase())) ||
            (item &&
              item.primary_restaurant_type[0] &&
              item.primary_restaurant_type[0].title &&
              item.primary_restaurant_type[0].title
                .toLowerCase()
                .includes(this.state.search.toLocaleLowerCase())) ||
            (item &&
              item.point_of_contact &&
              item.point_of_contact[0] &&
              item.point_of_contact[0].enquiry_emails &&
              item.point_of_contact[0].enquiry_emails[0] &&
              item.point_of_contact[0].enquiry_emails[0]
                .toLowerCase()
                .includes(this.state.search)) ||
            (item &&
              item.point_of_contact &&
              item.point_of_contact[0] &&
              item.point_of_contact[0].phone_numbers &&
              item.point_of_contact[0].phone_numbers[0] &&
              item.point_of_contact[0].phone_numbers[0].mobile_no
                .toLowerCase()
                .includes(this.state.search))) &&
            ((item &&
              this.state.startRatingSearch === "" &&
              this.state.endRatingSearch === "" &&
              item) ||
              (item &&
                this.state.startRatingSearch !== "" &&
                this.state.endRatingSearch !== "" &&
                item.averageRating >= this.state.startRatingSearch &&
                item.averageRating <= this.state.endRatingSearch &&
                item)) &&
            ((item && this.state.locationSearch === "" && item) ||
              (item &&
                this.state.locationSearch !== "" &&
                item.city &&
                item.city
                  .toLowerCase()
                  .includes(this.state.locationSearch.toLowerCase()))) &&
            ((item &&
              this.state.startDateSearch === "" &&
              this.state.endDateSearch === "" &&
              item) ||
              (item &&
                item.createdAt &&
                this.state.startDateSearch !== "" &&
                this.state.endDateSearch !== "" &&
                this.state.startDateSearch <=
                  moment(item.createdAt).format("YYYY-MM-DD") &&
                moment(item.createdAt).format("YYYY-MM-DD") <=
                  this.state.endDateSearch)) &&
            item &&
            item.primary_restaurant_type[0] &&
            item.primary_restaurant_type[0].title &&
            item.primary_restaurant_type[0].title
              .toLowerCase()
              .includes(this.state.resTypeSearch.toLocaleLowerCase())) ||
          item?.vendor?.referral_code
            ?.toLowerCase()
            ?.includes(this.state.search?.toLowerCase())
        );
      });
    filtereddata =
      filtereddata &&
      filtereddata.filter((item, index) => {
        let status = getBusinessTimingsStatus(item);
        filtereddata[index].statusOnline = status.value;
        filtereddata[index].statusSort = status.sortValue;

        if (this.state.statusFilter !== "") {
          return status.value === this.state.statusFilter;
        } else return true;
      });

    if (this.state.softOnboardedSearch === true) {
      filtereddata =
        filtereddata &&
        filtereddata.filter(
          (activeVendor) => activeVendor?.softOnboarding === true
        );
    }

    if (!isEmpty(filtereddata)) {
      return filtereddata
        .sort((a, b) => {
          if (this.state.sortByStatus === 1) return a.statusSort - b.statusSort;
          if (this.state.sortByStatus === 2) return b.statusSort - a.statusSort;
          return 0;
        })
        .slice(start, end)
        .map((data, index) => {
          return (
            <React.Fragment key={index}>
              <AllVendorTableBody
                vendorData={data}
                email={data.enquiry_email[0]}
                primaryPhone={
                  data.contact_detail[0].country_code +
                  " " +
                  data.contact_detail[0].mobile_no
                }
                statusOnline={data?.statusOnline}
                sendData={filtereddata}
                setDataWhole={(e) => this.setState({ downloadData: e })}
                ratingReviewActionId={this.ratingReviewAction(data)}
                adminSeatingDashboard={this.adminSeatingDashboardAction(data)}
                handleProfileClick={this.handleProfileClick(data)}
                onClickEditButton={this.handleEditMerchantData(data)}
                toggleFunction={this.approvedPendingAction(data)}
                restaurantClosedTime="11:00 pm"
                restaurantWaitTime="40-50 mins"
                restaurantAddress="Survey N0:32/2, Gurukrupa Hall, Near Dmart, Ambegaon bK, pune, maharashtra 411046"
                restaurantCity="pune"
                restaurantLocation="hadapsar post"
                restaurantType="fine dine"
                restaurantCuisine="italian"
                foodType="Organic"
                restaurantMemberSince="25/08/2019"
                displayStatus={true}
              />
            </React.Fragment>
          );
        });
    }
  };

  render() {
    // if (this.props.auth.loader) {
    //   return (
    //     <React.Fragment>
    //       <AmealioLoader />
    //     </React.Fragment>
    //   );
    // } else {
    const downloadData = {
      headers: [
        { label: "Business Id", key: "bid" },
        { label: "Business Name", key: "bname" },
        { label: "status", key: "statusonline" },
        { label: "POC name", key: "contact" },
        { label: "Mobile number", key: "pocnumber" },
        { label: "Email Id", key: "pocemail" },
        { label: "Address", key: "address" },
        { label: "Restaurant Type", key: "restype" },
        { label: "Last Updated", key: "updatedAt" },
      ],
      data: this.state.downloadData
        ? this.state.downloadData?.map((ele) => {
            let status = getBusinessTimingsStatus(ele);
            // console.log(ele?.restaurant_name, "******ele***");
            return {
              bid: ele?._id.substr(ele?._id.length - 15),
              bname: ele?.restaurant_name,
              statusonline: statuses[status.value]?.title,
              contact: `${
                ele?.point_of_contact.length &&
                (ele?.point_of_contact[0]?.firstName || " ") +
                  " " +
                  (ele?.point_of_contact[0]?.lastName || "")
              }`,
              pocnumber: `${
                ele?.contact_detail[0]?.mobile_no?.country_code ||
                " " + ele?.contact_detail[0]?.mobile_no ||
                " "
              }`,
              pocemail: `${ele?.enquiry_email[0] || ""}`,
              address: `${ele?.city || ""} \n ${ele?.area} \n ${ele?.pinCode}`,
              restype:
                ele?.primary_restaurant_type.length !== 0
                  ? ele?.primary_restaurant_type[0].title
                  : "" || "",
              updatedAt: `${moment(new Date(ele?.updatedAt)).format(
                "DD-MM-YYYY HH:MM A"
              )}`,
            };
          })
        : [],
    };
    return (
      <React.Fragment>
        <div className="container-fluid">
          <div className="row">
            <div className="left-side-panel">
              <LeftSideNavigation displayLink={1} />
            </div>
            <div className="super-admin-right-side-panel">
              <HomeReusableTopBarNavigation displayText="All Active Vendors" />
              <div className="super-admin-inside-right-side-panel">
                <div className="seating_dashboard_top_new_header">
                  <div className="row">
                    <div className="col-6">
                      <h4>All Active Vendors</h4>
                    </div>
                    <div className="col-6 text-right">
                      <button
                        onClick={(e) => this.props.history.push("/addvendor")}
                        className="btn add_button_custom_1"
                      >
                        + Add Vendor
                      </button>
                    </div>
                  </div>
                </div>
                <div className="d-flex justify-content-end mt-3 mb-3">
                  <RightSideCountTop
                    content={[
                      {
                        name: "Active Vendors",
                        value: `${
                          this.state?.activeCount !== undefined
                            ? this.state?.activeCount
                            : 0
                        }`,
                        backgroundColor: "#EFEBFB",
                        color: "#6F32C9",
                      },
                      {
                        name: "Total number of Vendors",
                        value: `${
                          this.state?.totalCount !== undefined
                            ? this.state?.totalCount
                            : 0
                        }`,
                        backgroundColor: "#D8F3F4",
                        color: "#008B90",
                      },
                    ]}
                  />
                </div>
                <FilterAllVendorsActive
                  handleShowFilter={this.handleShowFilter}
                  showFilter={this.state.displayFilter}
                  statusFilter={this.state.statusFilter}
                  sortBy={this.state.sortBy}
                  statusFilterHandle={(e) =>
                    this.setState({ statusFilter: e.target.value })
                  }
                  onChange={(e) => this.setState({ search: e.target.value })}
                  search={this.state.search}
                  sortByChangeCode={this.sortByChangeCode}
                  handleSaveButton={() => this.onClickSearchButton()}
                  startDate={this.state.startDate}
                  endDate={this.state.endDate}
                  onStartDateChange={(e) =>
                    this.setState({ startDate: e.target.value })
                  }
                  onEndDateChange={(e) =>
                    this.setState({ endDate: e.target.value })
                  }
                  location={this.state.location}
                  onChangeLocation={(e) =>
                    this.setState({ location: e.target.value })
                  }
                  rating={this.state.rating}
                  ratingChangeCode={(e) =>
                    this.setState({ rating: e.target.value })
                  }
                  categoryList={this.state.categoryList}
                  resType={this.state.resType}
                  resTypeChangeHandler={(e) =>
                    this.setState({ resType: e.target.value })
                  }
                  sortMenuButton={
                    <SortComponent
                      handleClick={this.handleClick}
                      anchorEl={this.state.anchorEl}
                      handleClose={this.handleClose}
                      selectClick={(data) => this.handleSelect(data)}
                      statusSortHandle={(data) =>
                        this.setState({ sortByStatus: data })
                      }
                      sortImgWidth={true}
                    />
                  }
                  downloadButton={
                    <CSVDownloader
                      filename="Active vendors Reports"
                      headers={downloadData.headers}
                      data={downloadData.data}
                      sortImgWidth={true}
                    />
                  }
                  softOnboarded={this.state.softOnboarded}
                  onChangeSoftOnboarded={this.handleChange}
                />
                {/* <SuperAdminTopTextSearchIcon
                  showFilter={this.state.displayFilter}
                  handleShowFilter={this.handleShowFilter}
                  handleSaveButton={this.handleShowFilter}
                  onChange={this.onSearchChange}
                  search={this.state.search}
                /> */}
                <div className="col-12 p-0 user-table-reusable-superadmin super-admin-all-vendor-main">
                  <Table>
                    <thead>
                      <AllVendorTableHead />
                    </thead>
                    {this.state.adminAllActiveDiners?.length ? (
                      this.state.adminAllActiveDiners === undefined ||
                      this.props.auth.secondary_loader === true ? (
                        <React.Fragment>
                          <SmallLoader />
                        </React.Fragment>
                      ) : (
                        this.renderAllVendorsBody()
                      )
                    ) : (
                      <NoContent />
                    )}
                  </Table>
                </div>
                {this.state?.adminAllActiveDiners?.length > 0 && (
                  <BasicPagination
                    totalRecords={this.state.adminAllActiveDiners.length}
                    limit={10}
                    batch={this.state.page}
                    onBatchChange={(e) => this.handleBatchChange(e)}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
    // }
  }
}

SuperAdminMainVendorComponent.propTypes = {
  admin_active_vendors: PropTypes.array.isRequired,
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  getSubCateogryWithCategoryId: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  admin_active_vendors: state.adminAllVendorsInfo.superAdminAllActiveVendors,
  auth: state.auth,
  errors: state.errors.errors,
});

export default connect(mapStateToProps, {
  clear_all_errors,
  get_all_admin_active_vendors,
  get_vendor_single_rating_review,
  superadmin_approved_notapproved,
  get_all_vendor_seating_information,
  get_single_vendor_restaurant_information,
  getSubCateogryWithCategoryId,
})(withRouter(SuperAdminMainVendorComponent));
